import * as angular from "angular";
import {IController, IQService} from "angular";
import * as _ from "lodash";

export class customersAutocompleteCtrl implements IController {

  accountIds: any;
  accountId: any;
  allowGlobal: any;
  clearTextOnSelect: any;
  searchQuery: any;
  isRequired: any;
  label: any;
  avoidIds: any;
  ngDisabled: any;
  ngRequired: any;
  onSelect: Function;
  onSearchChange: Function;

  private customersRef: any;
  private hasPermission: any;

  /* @ngInject */
  constructor(private $customers, private IAMPermissions, private $q: IQService) {
  }

  $onInit() {
    this.customersRef = this.$customers()
    this.hasPermission = this.IAMPermissions.hasPermission('customer.list');

    if (!this.label) {
      this.label = 'Search Customers';
    }
    if (!this.isRequired) {
      this.isRequired = false;
    }
    if (!this.searchQuery) {
      this.searchQuery = null;
    }
    // if (!this.disabled) {
    //     this.disabled = false;
    // }
  }

  customerNameFilter(customer) {
    return customer.firstName + ' ' + customer.lastName;
  }

  onSearch(searchQuery) {

    if (this.hasPermission) {
      const query = {
        limit: 10,
        descending: true,
        accountIds: this.accountId ? [this.accountId] : this.accountIds,
        allowGlobal: this.allowGlobal,
        query: searchQuery
      };

      return this.customersRef.$getAll(query)
        .then((customerIds) => {
          if (this.avoidIds && !_.isEmpty(this.avoidIds)) {
            customerIds = _.filter(customerIds, (customerId) => {
              return _.indexOf(this.avoidIds, customerId) === -1
            })
          }
          return this.customersRef.$asyncValues(customerIds);
        })
    } else {
      return this.$q.when([]);
    }
  }

  onSelectItem(item) {
    if (item) {
      if (this.clearTextOnSelect) {
        this.searchQuery = null;
      }
      this.onSelect({customer: item})
    }

  }

  searchChanged(searchQuery) {
    this.onSearchChange({searchText: searchQuery});
    // ctrl.onSelect({customer: undefined, searchText: searchQuery})
  }

  getCustomerAddress(item) {
    return _.find(item.addresses, (address) => {
      return address.id === item.defaultAddressId;
    })
  }

}

angular
  .module('bringoz.admin.customers')
  .component('customersAutocomplete', {
    require: {
      form: '^form'
    },
    bindings: {
      accountIds: '<?',
      accountId: '<?',
      allowGlobal: '<?',
      clearTextOnSelect: '<',
      searchQuery: '<?',
      isRequired: '@?',
      label: '<?',
      avoidIds: '<?',
      ngDisabled: '<?',
      ngRequired: '@?',
      onSelect: '&',
      onSearchChange: '&'
    },
    template: require('./customers-autocomplete.html').default,
    controller: customersAutocompleteCtrl
  });
